import React, { useState } from "react";
import {
  Button,
  Typography,
  Paper,
  CircularProgress,
  Divider,
  Box,
} from "@mui/material";
import BackupIcon from "@mui/icons-material/Backup";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { createDatabaseBackup } from "../../../services/api/setting";
import { useDispatch } from "react-redux";

const Backup = () => {
  const dispatch = useDispatch();
  // -----------useState----------------------
  const [loading, setLoading] = useState(false);
  const [backupFileName, setBackupFileName] = useState(null);

  // Handle form submission
  const handleBackup = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await createDatabaseBackup();
      setBackupFileName(data.data.fileName);
      dispatch(showToast({ message: data.message, severity: "success" }));
    } catch (error) {
      dispatch(showToast({ message: error.message, severity: "error" }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        mb: 3,
        p: 2.5,
        borderRadius: 2,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
      }}
    >
      <Typography variant="h5" gutterBottom>
        Backup Management
      </Typography>
      <Typography variant="body1" gutterBottom color="text.secondary">
        Click the button below to generate and download a backup of the current
        database. This is useful for data recovery and migration purposes.
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Box display="flex" alignItems="center" gap={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleBackup}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : <BackupIcon />}
        >
          {loading ? "Creating Backup..." : "Create Backup"}
        </Button>

        {backupFileName && !loading && (
          <Box display="flex" alignItems="center" gap={1}>
            <CheckCircleOutlineIcon color="success" />
            <Typography variant="body2" color="success.main">
              {backupFileName} downloaded
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default Backup;
